import { FlexBox } from '@fable/components'
import { css, cx } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { useStatsPermission } from '../../lib/hooks'
import { StatsMenu } from './stats_menu'
import { StatsYearSelector } from './year_selector/StatsYearSelector'

export const StatsHeader = () => {
  const status = useStats((s) => s.status)
  const { isAuthStatsOwner } = useStatsPermission()

  return (
    <div
      className={css`
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
      `}
    >
      <FlexBox
        className={cx(
          css`
            padding: 24px 20px 12px;
            width: 100%;
            pointer-events: ${status === 'loadingYear' ? 'none' : 'auto'};
            gap: 4px;
          `
        )}
        justifyContent="space-between"
        alignItems="center"
      >
        <StatsYearSelector />
        {isAuthStatsOwner ? <StatsMenu /> : null}
      </FlexBox>
    </div>
  )
}
